var map = {
	"./Leopard Diary Logo 50x50.png": 73,
	"./Leopard Diary Logo Balck.png": 387,
	"./Leopard Diary Logo Only.png": 388,
	"./Yala Leopard Diary Logo.png": 389,
	"./landing-background-mobile.jpg": 390,
	"./landing-background-old.jpg": 391,
	"./landing-background-tab.jpg": 392,
	"./landing-background-without-watermark.jpg": 393,
	"./landing-background.jpg": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1674;